import React from 'react';

export type LoaderProps = {
  loaderText: string;
};

function Loader({ loaderText }: LoaderProps) {
  return (
    <div className="loader" role="alert" aria-live="assertive">
      <div className="loader__square"></div>
      <p className="loader__text">{loaderText}</p>
    </div>
  );
}

export default Loader;
